import { branch, renderComponent } from 'recompose';

// yes I know... it's almost exactly as the official documentation
const withTutorial = (Content) => branch(({ items }) => 0 === items.length, renderComponent(Content));

export default withTutorial;
